import React from 'react';
import PropTypes from 'prop-types';
import { articlePropTypes } from 'app/selectors/support';
import Video from '../support/video';

import './article-step-group.less';

const ArticleStepGroup = ({ article }) => {
  const { id, title, entries } = article.fields;

  return (
    <div id={id} className='stepGroup'>
      {title && <h2 className='title'>{title}</h2>}

      {entries.map((entry) => {
        const { steps, video, slug } = entry.fields;

        return (
          <div key={slug} className='entry'>
            <ol className='steps'>
              {steps &&
                steps.map((step) => {
                  const { stepNumber, text } = step.fields;

                  return (
                    <li key={`aura-unboxing-step-${stepNumber}`} className='step'>
                      <h3 className='stepNumber'>{stepNumber}</h3>
                      <span className='stepText'>{text}</span>
                    </li>
                  );
                })}
            </ol>

            {video && (
              <div className='video-container'>
                <Video src={video[0].fields.file.url} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

ArticleStepGroup.propTypes = {
  article: PropTypes.shape(articlePropTypes),
};

ArticleStepGroup.defaultProps = {
  article: {},
};

export default ArticleStepGroup;



// WEBPACK FOOTER //
// ./app/components/setup/article-step-group.jsx